import { useSearchParams } from 'react-router-dom'

import { useWidgetGetApi } from '@/common/api/modules/widget'
import { widgetListPath } from '@/common/app/path'
import { useSiteId } from '@/common/app/site'
import { Widget } from '@/common/model/recommend/widget'

import BackButton from '@/components/view/atoms/button/BackButton'
import Main from '@/components/view/layouts/page/Main'

import WidgetForm from '@/components/container/form/modules/recommend/widget/WidgetForm'
import WidgetDisplayLogicModalProvider from '@/components/container/modal/widget/displayLogic/WidgetDisplayLogicModalProvider'
import VisualCssEditorModalProvider from '@/components/container/modal/widget/visualCssEditor/VisualCssEditorModalProvider'

interface Props {
  widget?: Widget
  onRefetch?: () => void
}

const WidgetEditPage = ({ widget, onRefetch }: Props) => {
  const siteId = useSiteId()
  // 新規作成時のみ ?copiedId=XXX で複製元を取得し、フォーム初期値に反映する
  const [searchParams] = useSearchParams()
  const copiedId = !widget ? searchParams.get('copiedId') : null
  const { data: copySource } = useWidgetGetApi({
    siteId,
    widgetId: copiedId ? Number(copiedId) : undefined
  })

  return (
    <WidgetDisplayLogicModalProvider>
      <VisualCssEditorModalProvider>
        <Main>
          <BackButton link={widgetListPath(siteId)} />
          <WidgetForm widget={widget} copySource={copySource} onRefetch={onRefetch} />
        </Main>
      </VisualCssEditorModalProvider>
    </WidgetDisplayLogicModalProvider>
  )
}

export default WidgetEditPage
